import { GridContextMenuItems, IGridContextMenuService } from './grid-context-menu.interface';
import { injectable } from 'inversify';

@injectable()
export class GridContextMenuMock implements IGridContextMenuService {
    init(): void {
        throw new Error('Method not implemented.');
    }
    getMenuItems(): GridContextMenuItems {
        return [];
    }
}
